import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { JVInput } from "../../shared/JVInput";
import { Dialog } from "primereact/dialog";
import { JVDropdown } from "../../shared/JVDropdown";
import { useEffect, useState } from "react";
import { JVSunEditor } from "../../shared/JVSuneditor";
import { Fetch } from "../../shared/Fetch";
import { Button } from "primereact/button";

interface IProps {
    open: boolean,
    tableData: any,
    onClose: () => void;
    toast: any,
}

interface ISendEmail {
    to?: string | null,
    moreEmails?: string | null,
    subject?: string | null,
    req?: number | null,
}

const EmptyForm: ISendEmail = {
    to: "",
    moreEmails: "",
    subject: "",
    req: null,
};

interface IReq_List {
    req_ID: number | null,
    req_Name: string | null,
    req_JobDescription: string | null,
}

const schema = yup.object({
    to: yup.string().required(),
    moreEmails: yup.string().nullable(),
    subject: yup.string().required("Subject is required"),
    req: yup.string().nullable(),
});

export const SendEmail = (props: IProps) => {
    const [loading, setLoading] = useState(false);
    const [loadingReq, setLoadingReq] = useState(false);
    const [mailBody, setMailBody] = useState("");
    const [reqList, setReqList] = useState<IReq_List[]>([]);

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue, setError, setFocus } = useForm<ISendEmail>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false
    });

    const onSubmit = async (data: ISendEmail) => {
        if (mailBody.trim() === "") {
            props.toast.current.show({ severity: 'error', detail: 'Mail Body Can not be empty', life: 3000 });
        } else {
            setLoading(true);
            const newData = { ...data, req: data.req, Consultant_ID: props.tableData.map((el: any) => el.consultant_ID), mailBody: mailBody.trim() };
            const response = await Fetch("Consultant_Mast/sendEmailForAsking", "POST", newData, null, props.toast);
            if (response) {
                props.toast.current.show({ severity: 'success', detail: 'Email Send Successfully', life: 3000 });
                setLoading(false);
                onClose();
            } else {
                setLoading(false);
            }
        }
    }

    const loadReqList = async () => {
        setLoadingReq(true);
        const response = await Fetch("Consultant_Mast/getAllocatedReqs", "GET", null, null, props.toast);
        if (response) {
            const data: IReq_List[] = await response.json();
            setReqList(data);
            setLoadingReq(false);
        } else {
            setLoadingReq(false);
        }
    }

    const onClose = () => {
        reset(EmptyForm);
        setMailBody("");
        props.onClose();
    }
    //
    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "req") {
                if (value.req !== null && value.req !== 0) {
                    const text = "Job Descriptions : \n" + (reqList.filter(e => e.req_ID === value.req)[0]?.req_JobDescription || "");
                    setMailBody(text);
                }
            }
        });
        return () => subscription.unsubscribe();
    }, [watch, mailBody, reqList]);

    useEffect(() => {
        if (props.open) loadReqList();
        if (props.open && props.tableData?.length > 0) {
            reset(EmptyForm);
            setMailBody("");
            setValue("to", props.tableData?.map((el: any) => el.consultant_Email_ID).join(","));
            // setValue("subject", `Resume for ${props.tableData?.consultant_Name}`);
            // setFocus("to");
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Mass Mail" modal className="p-fluid" onHide={onClose}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <div className='field col-12 md:col-12'>
                    <label>To:</label>
                    <p className="border-1 border-round border-400 pl-2 pt-2" style={{ height: "34px" }}>{props.tableData?.map((el: any) => el.consultant_Email_ID).length} Consultant's</p>
                </div>
                {/* <JVInput column={1} label="Add More Email:" control={control} name="moreEmails" error={errors.moreEmails?.message} /> */}
                <JVInput column={2} label="Subject:" control={control} name="subject" error={errors.subject?.message} />
                {loadingReq && "Loading Req..."}
                {!loadingReq && <JVDropdown column={2} label="Req" control={control} name="req" options={reqList} optionLabel="req_Name" optionValue="req_ID" placeholder="Select Req ID" error={errors.req?.message} />}
                <JVSunEditor value={mailBody} handleChange={setMailBody} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} disabled={loading} loading={loading} label="Send" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="Cancel" onClick={onClose} type="button" className="p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}